import { ReactNode } from 'react';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import { CoreBox, CoreTypography } from '@youscience/core';
import { brightpathTheme } from '@youscience/theme';

import CardExpandButton from '@components/CardExpandButton';

import CheckMarkIcon from '@images/checkmark-in-cercle.svg?react';
import WarningIcon from '@images/warning.svg?react';
interface SectionAccordionProps {
  title: string;
  isExpanded: boolean;
  onChange: () => void;
  children: ReactNode;
  showCheckmark?: boolean;
  isChanged?: boolean;
  isError?: boolean;
}

const notificationIcon = (props: SectionAccordionProps) => {
  const { showCheckmark, isChanged, isError } = props;
  if (isError) {
    return (
      <CoreBox sx={{ display: 'flex', gap: '.5rem' }}>
        <WarningIcon /> <CoreTypography variant="body1">Please complete all required fields.</CoreTypography>
      </CoreBox>
    );
  } else if (showCheckmark && !isChanged) {
    return (
      <CoreBox sx={{ display: 'flex', gap: '.5rem' }}>
        <CheckMarkIcon />
      </CoreBox>
    );
  } else if (isChanged) {
    return (
      <CoreBox sx={{ display: 'flex', gap: '.5rem' }}>
        <WarningIcon /> <CoreTypography variant="body1">You have unsaved updates</CoreTypography>
      </CoreBox>
    );
  } else {
    return null;
  }
};

export const SectionAccordion = (props: SectionAccordionProps) => {
  const { title, isExpanded, onChange, children } = props;

  return (
    <Accordion
      expanded={isExpanded}
      onChange={onChange}
      sx={{
        padding: '0rem 1rem',
        background: brightpathTheme.palette.common.white,
        borderRadius: '.5rem',
        boxShadow: 'none',
        '&:before': {
          backgroundColor: 'transparent !important',
        },
      }}
      disableGutters
    >
      <AccordionSummary
        sx={{ padding: '0', '> div': { margin: '0', display: 'flex', justifyContent: 'space-between' } }}
      >
        <CoreBox sx={{ display: 'flex', gap: '1rem', alignItems: 'center', padding: '0' }}>
          <CoreTypography variant="subtitle2">{title}</CoreTypography>
          <CoreBox>{notificationIcon(props)}</CoreBox>
        </CoreBox>
        <CardExpandButton isExtended={isExpanded} onExtendedToggle={onChange} />
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
};
